import React, { useEffect, useState } from "react";
import {
  FormControl,
  FormLabel,
  HStack,
  Icon,
  Input,
  Menu,
  MenuItem,
  MenuList,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Text,
  VStack,
  useDisclosure,
} from "@chakra-ui/react";
import { FaChevronDown } from "react-icons/fa";
import { useLang } from "../../../../Hooks";
import { ReportActionButton } from "../../Shared/Components/ReportActionButton";
import { ReportFilterButton } from "../../Shared/Components/ReportFilterButton";
import { ReportMenuButton } from "../../Shared/Components/ReportMenuButton";
import { reportToolbarStyles } from "../../Shared/Styles/reportToolbarStyles";
import { CURRENCIES } from "../../balanceSheetConstants";
import { getEndOfMonth } from "../../balanceSheetUtils";

export function StructuralRatiosFilters({
  currentFilters,
  onApplyFilters,
  onCurrencyChange,
}) {
  const { texts } = useLang();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const defaultDate = getEndOfMonth(new Date().toISOString().split("T")[0]);
  const [selectedDate, setSelectedDate] = useState(
    (currentFilters.date || defaultDate).slice(0, 7)
  );

  useEffect(() => {
    setSelectedDate((currentFilters.date || defaultDate).slice(0, 7));
  }, [currentFilters.date, defaultDate]);

  const selectedCurrency =
    CURRENCIES.find((currency) => currency.code === currentFilters.currency) ||
    CURRENCIES[0];

  const apply = () => {
    onApplyFilters({
      date: getEndOfMonth(selectedDate),
      currency: currentFilters.currency,
    });
    onClose();
  };

  const clear = () => {
    const clearedDate = getEndOfMonth(new Date().toISOString().split("T")[0]);
    setSelectedDate(clearedDate.slice(0, 7));
    onApplyFilters({
      date: clearedDate,
      currency: currentFilters.currency,
    });
    onClose();
  };

  return (
    <HStack spacing={2}>
      <Menu>
        <ReportMenuButton>
          <HStack spacing={2}>
            <Text fontSize="sm">
              {texts.reports?.figuresIn || "Figures in"} {selectedCurrency.label}
            </Text>
            <Icon as={FaChevronDown} />
          </HStack>
        </ReportMenuButton>
        <MenuList {...reportToolbarStyles.menuList}>
          {CURRENCIES.map((currency) => (
            <MenuItem
              key={currency.code}
              onClick={() => onCurrencyChange(currency.code)}
            >
              {currency.label}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
      <Popover
        isLazy
        isOpen={isOpen}
        placement="bottom-start"
        onOpen={onOpen}
        onClose={onClose}
      >
        <PopoverTrigger>
          <ReportFilterButton>{texts.reports?.filter || "Filter"}</ReportFilterButton>
        </PopoverTrigger>
        <PopoverContent {...reportToolbarStyles.popoverContent} w="360px">
          <PopoverArrow />
          <PopoverHeader fontWeight="bold">
            {texts.reports?.filter || "Filter"}
          </PopoverHeader>
          <PopoverCloseButton />
          <PopoverBody>
            <VStack align="stretch" spacing={4}>
              <FormControl>
                <FormLabel fontSize="sm">
                  {texts.reports?.asAtEndOf || "As at end of (Month/Year)"}
                </FormLabel>
                <Input
                  type="month"
                  value={selectedDate}
                  onChange={(event) => setSelectedDate(event.target.value)}
                  size="sm"
                />
              </FormControl>
              <HStack justify="end">
                <ReportActionButton variant="ghost" onClick={clear}>
                  {texts.reports?.clear || "Clear"}
                </ReportActionButton>
                <ReportActionButton variant="primary" onClick={apply}>
                  {texts.reports?.apply || "Apply"}
                </ReportActionButton>
              </HStack>
            </VStack>
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </HStack>
  );
}
